module.exports = __webpack_public_path__ + "fonts/noto-sans-v7-latin-70075d288254ebf75e35a355823ac2b3d8f.woff";